<div class="container d-flex flex-column align-items-center justify-content-center min-vh-100">

  <a routerLink="/"><img src="https://get.hubbleapp.ai/images/hubble-logo.svg" alt="Hubble Logo" style="max-width: 200px; margin-bottom: 3rem;"></a>

  <div class="card shadow-sm p-4" style="width: 100%; max-width: 400px;">
    <h3 class="text-center mb-4">Sign In</h3>
    <p class="text-center mb-4" style="color: grey; font-size: 14px;">No account yet? <a routerLink="/signup">Sign up</a></p>
    <form (submit)="signin(); $event.preventDefault()">
      <div class="mb-3">
        <label for="email" class="form-label">Email address</label>
        <input
          type="email"
          class="form-control"
          id="email"
          name="email"
          [(ngModel)]="email"
          placeholder="Enter email"
          required
        />
      </div>
      <div class="mb-3">
        <label for="password" class="form-label">Password</label>
        <input
          type="password"
          class="form-control"
          id="password"
          name="password"
          [(ngModel)]="password"
          placeholder="Password"
          required
        />
      </div>
      <div class="d-grid">
        <button 
          *ngIf="!loading" 
          type="submit" 
          class="btn btn-primary">
          Sign In
        </button>
        <div *ngIf="loading" class="d-flex justify-content-center">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
        <p style="margin-top: 15px; text-align: center; font-size: 14px;">
          <a href="#" (click)="onForgotPassword($event)">Forgot your password?</a>
        </p>
      </div>
      <div *ngIf="error" class="alert alert-danger mt-3" role="alert">
        {{ error }}
      </div>
    </form>
  </div>
</div>